import { useCallback, useEffect, useState } from 'react';

type Params = {
	refContainer: React.RefObject<HTMLDivElement | null>;
	onCloseSearchByImage?: () => void;
};

export function useSpotlightDropdown({ refContainer, onCloseSearchByImage }: Params) {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const openSpotlightDropdown = useCallback(() => setIsDropdownOpen(true), []);
	const closeSpotlightDropdown = useCallback(() => {
		setIsDropdownOpen(false);
		onCloseSearchByImage?.();
	}, [onCloseSearchByImage]);

	// Close the dropdown when the user clicks outside the spotlight container.
	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (!refContainer.current?.contains(e.target as Node)) {
				closeSpotlightDropdown();
			}
		};

		document.addEventListener('click', handleClickOutside);

		return () => document.removeEventListener('click', handleClickOutside);
	}, [closeSpotlightDropdown, refContainer]);

	return { isDropdownOpen, openSpotlightDropdown, closeSpotlightDropdown };
}
